import { createQueryKeyStore } from "@lukemorales/query-key-factory";
import { skipToken } from "@tanstack/react-query";

import type { AvailableLanguage } from "@/shared/models";
import type { GetFunnelIntakeParams } from "./intake";
import { getFunnelIntake } from "./intake";

const funnelQueriesStore = createQueryKeyStore({
  intake: {
    screens: (language: AvailableLanguage, params?: GetFunnelIntakeParams) => ({
      queryKey: [{ language, params }],
      queryFn: params ? () => getFunnelIntake(params) : (skipToken as never),
    }),
  },
});

// The query key store keeps only queryKey and queryFn, so the stale time has
// to be added wherever the screens are read or fetched.
export const funnelIntakeScreensQuery = (
  language: AvailableLanguage,
  params?: GetFunnelIntakeParams,
) => ({
  ...funnelQueriesStore.intake.screens(language, params),
  staleTime: Infinity,
});
